"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeUniqueID = exports.getHostname = exports.appendQueryParams = exports.isUrlExternal = exports.identity = exports.isBoolean = exports.isString = exports.isServer = exports.isBrowser = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

/**
 * Checks if window is an object
 */
var isBrowser = function isBrowser() {
  return (typeof window === "undefined" ? "undefined" : (0, _typeof2["default"])(window)) === "object";
};
/**
 * Returns the opposite of isBrowser
 */


exports.isBrowser = isBrowser;

var isServer = function isServer() {
  return !isBrowser();
};
/**
 * Checks if variable is a string
 */


exports.isServer = isServer;

var isString = function isString(variable) {
  return typeof variable === "string";
};
/**
 * Checks if variable is boolean
 */


exports.isString = isString;

var isBoolean = function isBoolean(variable) {
  return typeof variable === "boolean";
};
/**
 * @returns the argument ("x")
 */


exports.isBoolean = isBoolean;

var identity = function identity(x) {
  return x;
};
/**
 * CardShop Backend provides the Frontend with urls that are absolute
 * and relative. We can assume that urls given from the Backend that have the
 * protocol are external urls which are handled by different applications. If
 * the Backend provides us a url without a protocol we can assume its relative
 * and the route exists within our application
 * @param url url to test
 * @return `true` if url is external, otherwise `false`.
 */


exports.identity = identity;

var isUrlExternal = function isUrlExternal(url) {
  return !!(url && (url.indexOf("http") === 0 || url.indexOf("tel") === 0));
};
/**
 * Converts the params (obj) into an escaped string of query params
 * and appends it to the provided url
 *
 * @param url url to test
 * @param params params listed as an object
 * @return URL with query params
 * @example
 * const url = appendQueryParams('http://example.com', {
 *   experiment: 123
 * }) // -> http://example.com?experiment=123
 *
 * const url = appendQueryParams('http://example.com?something=true', {
 *   experiment: 123,
 *   another: 'param'
 * }) // -> http://example.com?something=true&experiment=123&another=param
 */


exports.isUrlExternal = isUrlExternal;

var appendQueryParams = function appendQueryParams(url, params) {
  var query = Object.keys(params).reduce(function (searchParams, key) {
    if (params[key]) {
      searchParams.push("".concat(key, "=").concat(encodeURIComponent(params[key])));
    }

    return searchParams;
  }, []).join("&");

  if (query.length > 0) {
    return url.includes("?") ? "".concat(url, "&").concat(query) : "".concat(url, "?").concat(query);
  }

  return url;
};
/**
 * Gets current hostname if called in browser, otherwise returns null.
 */


exports.appendQueryParams = appendQueryParams;

var getHostname = function getHostname() {
  if (isBrowser() && window.location && window.location.hostname) {
    return window.location.hostname;
  }

  return null;
};
/**
 * Makes unique id with 20 chars length as default
 * @param size total of chars wanted
 */


exports.getHostname = getHostname;

var makeUniqueID = function makeUniqueID() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;

  /*
  NOTE: This was taken from https://github.com/ai/nanoid/blob/main/non-secure/index.js#L6-L17
  because we require ES5 support (for IE) and the library does not provide it. Since we use
  babel to transpile out code, we cannot transpile the library.
  */
  var alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  var id = ""; // A compact alternative for `for (var i = 0; i < step; i++)`.

  var i = size;

  while (i--) {
    // `| 0` is more compact and faster than `Math.floor()`.
    id += alphabet[Math.random() * alphabet.length | 0];
  }

  return id;
};

exports.makeUniqueID = makeUniqueID;